export const GTM_CONTAINER_ID = 'GTM-TW4BH8';
export const GTM_TEST_ENV_AUTH = 'QfUvmNcAAz45B9rddiuryA';
export const GTM_TEST_ENV_PREVIEW = 'env-40';
export const GTM_DEBUG = false;
